import { put, takeEvery, call, all, select } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'

// import device services
import { getDevices, postDevice, putDevice, deleteDevice } from '../../services/device'

const getCurrentUser = state => state.user

export function* fetchDevices() {
  try {
    const user = yield select(getCurrentUser)
    const { data } = yield call(() => getDevices(user.token))
    yield put({
      type: actions.FETCH_DEVICES_SUCCESS,
      data,
    })
  } catch (error) {
    yield put({ type: actions.FETCH_DEVICES_ERROR, message: error.message })
  }
}

export function* setDevice(device) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los datos
    device.payload.projectMaster = JSON.parse(device.payload.projectMaster)
    device.payload.projectId = device.payload.projectMaster.projectId
    device.payload.projectUid = device.payload.projectMaster.projectUid
    device.payload.siteMaster = JSON.parse(device.payload.siteMaster)
    device.payload.siteId = device.payload.siteMaster.siteId
    device.payload.siteUid = device.payload.siteMaster.siteUid

    // ajusta los json
    device.payload.datetimedatajson = JSON.parse(device.payload.datetimedatajson)
    device.payload.sysdatajson = JSON.parse(device.payload.sysdatajson)
    device.payload.extradatajson = JSON.parse(device.payload.extradatajson)
    device.payload.operdatajson = JSON.parse(device.payload.operdatajson)
    device.payload.details = JSON.parse(device.payload.details)

    // agrego la empresa a sysdatajson
    device.payload.sysdatajson.companyUid = user.suscription.company.uid

    yield call(() => putDevice(user.token, device.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se han guardado exitósamente los cambios',
    })
    yield put({
      type: actions.FETCH_DEVICES,
    })
  } catch (error) {
    yield put({ type: actions.DEVICE_ERROR, message: error.message })
  }
}

export function* addDevice(device) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los datos
    console.log('payload', device.payload)
    device.payload.projectMaster = JSON.parse(device.payload.projectMaster)
    device.payload.projectId = device.payload.projectMaster.projectId
    device.payload.projectUid = device.payload.projectMaster.projectUid
    device.payload.siteMaster = JSON.parse(device.payload.siteMaster)
    device.payload.siteId = device.payload.siteMaster.siteId
    device.payload.siteUid = device.payload.siteMaster.siteUid

    // ajusta los json
    device.payload.sysdatajson = {}

    // agrego la empresa a sysdatajson
    device.payload.sysdatajson.companyUid = user.suscription.company.uid

    yield call(() => postDevice(user.token, device.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se ha agregado exitósamente el registro',
    })
    yield put({
      type: actions.FETCH_DEVICES,
    })
  } catch (error) {
    yield put({ type: actions.DEVICE_ERROR, message: error.message })
  }
}

export function* delDevice(device) {
  try {
    const user = yield select(getCurrentUser)
    yield call(() => deleteDevice(user.token, device.payload.uid))
    notification.success({
      message: 'Borrado exitoso',
      description: 'Se ha eliminado exitósamente el registro',
    })
    yield put({
      type: actions.FETCH_DEVICES,
    })
  } catch (error) {
    yield put({ type: actions.DEVICE_ERROR, message: error.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_DEVICES, fetchDevices),
    takeEvery(actions.DEVICE_SET, setDevice),
    takeEvery(actions.DEVICE_ADD, addDevice),
    takeEvery(actions.DEVICE_DEL, delDevice),
  ])
}
